import React, { useState } from 'react'
import MenuCard from './MenuCard'
import MenuLinkList from './MenuLinkList'
import MenuLang from './MenuLang'
import MenuSearch from './MenuSearch'
import { IMenuItem, ILanguageContent, ISearchContent } from '../../models'
import SubNavigationMobile from './SubNavigationMobile'
import SubNavigationDesk from './SubNavigationDesk'

function MenuMobile({
  menuItems,
  languageItems,
  searchContent,
}: {
  menuItems: IMenuItem[]
  languageItems: ILanguageContent[]
  searchContent: ISearchContent
}) {
  const [isOpen, setIsOpen] = useState(false)

  const [selectedItem, setSelectedItem] = useState<{
    [key: number]: IMenuItem | undefined
  }>({})

  const genericHamburgerLine = `h-[2px] w-8 my-1 rounded-full bg-black transition ease transform duration-300`

  const handleOpen = (status: boolean) => {
    const body = document.body
    setIsOpen(status)
    if (status) {
      body.style.overflowY = 'hidden'
    } else {
      body.style.overflowY = ''
    }
  }

  const handleSelectItem = (menuItem: IMenuItem, index: number) => {
    if (menuItem.IsDirectLink) {
      window.open(menuItem.LinkUrl, '_self')
      return
    }

    if (selectedItem[index]) {
      const newSelectedItem = selectedItem
      delete newSelectedItem[index]
      setSelectedItem((previous) => ({ ...previous, [index]: undefined }))

      return
    }
    setSelectedItem((previous) => ({ ...previous, [index]: menuItem }))
  }

  return (
    <div
      className="flex items-center justify-end  z-[100]
    "
    >
      <div
        className=" items-center hidden
      md:flex gap-8 mr-8"
      >
        <MenuSearch
          searchContent={searchContent}
          languageItems={languageItems}
          onOpen={(status) => {
            if (status) handleOpen(false)
          }}
        />
        <MenuLang languageItems={languageItems} />
      </div>
      <button
        className="flex flex-col h-8 w-8 justify-center items-center group "
        onClick={() => handleOpen(!isOpen)}
      >
        <div
          className={`${genericHamburgerLine} ${
            isOpen ? ' translate-y-[10px] ' : ''
          }`}
        />
        <div className={`${genericHamburgerLine} `} />
        <div
          className={`${genericHamburgerLine} ${
            isOpen ? ' -translate-y-[10px] ' : ''
          }`}
        />
      </button>

      <div
        className={`${
          isOpen ? ' opacity-100' : 'opacity-0'
        } transition-opacity  duration-500`}
      >
        {isOpen && (
          <div
            className="z-[100] flex flex-col absolute top-[80px] left-0 w-full h-[calc(100dvh-80px)] xl:h-screen bg-white  overflow-y-auto
        
          "
          >
            <div
              className="flex gap-[22px] items-center justify-end border-t-[1px]  border-separators-grey px-4 py-4 bg-white
            md:hidden  "
            >
              <MenuSearch
                searchContent={searchContent}
                languageItems={languageItems}
              />
              <MenuLang languageItems={languageItems} />
            </div>
            {menuItems.map((menuItem, index) => (
              <div
                className="border-t-[1px] border-separators-grey last:border-b-[1px] "
                key={index}
              >
                <div
                  className={`px-4 py-4 ${
                    menuItem.Highlight ? 'bg-visionary-green-3' : 'bg-white '
                  } 
                  md:px-6 `}
                  onClick={() => handleSelectItem(menuItem, index)}
                >
                  {menuItem.IsDirectLink && (
                    <a
                      key={index}
                      className="link link-text-menu py-[10px] inline-flex border-0 font-normal"
                      href={menuItem.LinkUrl}
                      target="_self"
                    >
                      {menuItem.MenuTitle}
                    </a>
                  )}
                  {!menuItem.IsDirectLink && (
                    <a
                      key={index}
                      className="link link-chevron-down hover:border-white py-[10px] font-normal"
                    >
                      {menuItem.MenuTitle}
                    </a>
                  )}
                </div>
                <div className="bg-white">
                  <div
                    className={`${
                      selectedItem[index] ? ' opacity-100' : 'opacity-0'
                    } transition-opacity  duration-500`}
                  >
                    {selectedItem[index] !== undefined &&
                      !selectedItem[index]?.IsDirectLink && (
                        <div
                          className="z-30 w-full bg-white p-4 pb-8 flex  gap-4 border-[1px] flex-col border-separators-grey
                    md:flex-row md:px-7 md:gap-[30px] md:py-0"
                        >
                          {selectedItem[index]?.LeftSide && (
                            <div
                              className={`flex gap-[30px]  flex-col
                          md:flex-row md:pr-[30px] md:py-7 ${
                            selectedItem[index]?.RightSide
                              ? 'md:border-r-[1px]  md:border-separators-grey'
                              : ''
                          }`}
                            >
                              {(selectedItem[index]?.LeftSide.Heading ||
                                selectedItem[index]?.LeftSide.Text) && (
                                <MenuCard
                                  heading={
                                    selectedItem[index]?.LeftSide.Heading || ''
                                  }
                                  text={
                                    selectedItem[index]?.LeftSide.Text || ''
                                  }
                                  imageUrl={
                                    selectedItem[index]?.LeftSide.ImageUrl
                                  }
                                  link={selectedItem[index]?.LeftSide.Link}
                                />
                              )}

                              {selectedItem[index]!.LeftSide.SubLinks.length >
                                0 && (
                                <MenuLinkList
                                  subLinks={
                                    selectedItem[index]?.LeftSide.SubLinks || []
                                  }
                                />
                              )}
                            </div>
                          )}
                          {selectedItem[index]?.RightSide && (
                            <div className="flex flex-col gap-[30px] md:py-7">
                              <div
                                className="flex flex-col gap-[30px]
                                md:flex-row md:pr-[30px]
                                  "
                              >
                                {selectedItem[index]?.RightSide.map(
                                  (element) => {
                                    if ('Heading' in element) {
                                      return (
                                        <MenuCard
                                          heading={element.Heading}
                                          text={element.Teaser}
                                          imageUrl={element.ImageUrl}
                                          link={element.Link}
                                          linkText={false}
                                        />
                                      )
                                    }
                                    if (
                                      'LinkList' in element &&
                                      element.LinkList?.length > 0
                                    ) {
                                      return (
                                        <MenuLinkList
                                          subLinks={element.LinkList}
                                        />
                                      )
                                    }
                                    if (
                                      'Tabs' in element &&
                                      element.Tabs?.length > 0
                                    ) {
                                      return (
                                        <>
                                          <div className="md:hidden">
                                            <SubNavigationMobile
                                              tabs={element.Tabs}
                                            />
                                          </div>
                                          <div className="hidden md:block w-max">
                                            <SubNavigationDesk
                                              tabs={element.Tabs}
                                            />
                                          </div>
                                        </>
                                      )
                                    }
                                  }
                                )}
                              </div>
                              {selectedItem[index]?.InfoBox && (
                                <div className=" bg-engineering-grey-4 p-4 gap-1 flex flex-col">
                                  <div className="md:w-[402px]">
                                    <p>
                                      <b>
                                        {selectedItem[index]?.InfoBox?.Heading}
                                      </b>
                                    </p>
                                    <p className="py-1 text-sm">
                                      {selectedItem[index]?.InfoBox?.Teaser}
                                    </p>
                                  </div>
                                  <div className="py-[5px]">
                                    <a
                                      className="link link-text "
                                      href={
                                        selectedItem[index]?.InfoBox?.Link.Url
                                      }
                                      target={
                                        selectedItem[index]?.InfoBox?.Link
                                          .Target
                                      }
                                    >
                                      {selectedItem[index]?.InfoBox?.Link.Name}
                                    </a>
                                  </div>
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                      )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}

export default MenuMobile
